import { Heading, HStack, VStack, Text, Box } from '@chakra-ui/layout'
import { IconButton } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { use100vh } from 'react-div-100vh'
import { useHistory } from 'react-router'
import useNotificationStore from '../state/Notification.store'

const Notifications = () => {
  const history = useHistory()
  const height = use100vh()
  const [notifications, markRead] = useNotificationStore((state) => [
    state.notifications,
    state.markRead
  ])

  useEffect(() => {
    return () => markRead()
  }, [markRead])

  return (
    <Box
      pos="relative"
      flexDir="column"
      maxW={{ md: '480px' }}
      w="full"
      mx="auto"
      pt="2rem"
      h={height || undefined}>
      <HStack px="2.4rem" pb="1rem">
        <IconButton
          justifyContent="flex-start"
          onClick={() => history.goBack()}
          color="transparent"
          bg="transparent"
          w="30px"
          _hover={{ bg: 'transparent' }}
          _active={{ bg: 'transparent' }}
          _focus={{ bg: 'transparent' }}
          aria-label="Search database"
          icon={
            <svg
              width="15"
              height="14"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.4451 6.10003H14.3996V7.89997H3.4451L8.27256 12.7274L7 14L0 7L7 0L8.27256 1.27256L3.4451 6.10003Z"
                fill="#2E279D"
              />
            </svg>
          }
        />
        <Heading
          fontWeight="600"
          ml="-48px !important"
          flex="1"
          textAlign="center"
          fontSize="1.6rem"
          color="black">
          Notifications
        </Heading>
      </HStack>

      {notifications.map((notification, index) => (
        <HStack
          key={`${index + 1}`}
          pl="1.2rem"
          pr="2.4rem"
          bg={notification.read ? 'white' : 'rgba(70, 179, 230, 0.05)'}
          spacing="0.8rem"
          align="flex-start">
          {!notification.read && (
            <svg
              width="4"
              height="4"
              style={{ marginTop: '2.4rem', marginRight: '0.8rem' }}
              viewBox="0 0 4 4"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <circle cx="2" cy="2" r="2" fill="#4D80E4" />
            </svg>
          )}

          <HStack
            ml={notification.read ? '2rem' : 0}
            py="1.7rem"
            borderTop={index === 0 ? '1px solid #e7e6e6' : ''}
            borderBottom="1px solid #e7e6e6"
            justify="space-between"
            align="flex-start"
            flex="1">
            <VStack align="flex-start">
              <Text color="black" fontWeight="500" fontSize="1.2rem">
                {notification.title}
              </Text>
              <Text fontSize="1rem">{notification.body}</Text>
            </VStack>
            <Text fontSize="1rem">12:25PM</Text>
          </HStack>
        </HStack>
      ))}
    </Box>
  )
}

export { Notifications }
